/**
 * Penilaian Individu Module Routes
 */

import { Routes, Route, Navigate } from 'react-router-dom'
import PenilaianPeriodsPage from './pages/PenilaianPeriodsPage'
import MyAssessmentsPage from './pages/MyAssessmentsPage'
import AssessmentFormPage from './pages/AssessmentFormPage'
import MyResultPage from './pages/MyResultPage'
import PenilaianResultsPage from './pages/PenilaianResultsPage'
import PeerAssignmentAdminPage from './pages/PeerAssignmentAdminPage'
import PenilaianKPIPage from './pages/PenilaianKPIPage'
import MyKPIPage from './pages/MyKPIPage'
import TeamKPIPage from './pages/TeamKPIPage'
import AllKPIPlansPage from './pages/AllKPIPlansPage'
import PeriodDetailPage from './pages/PeriodDetailPage'
import MasterDataPage from './pages/MasterDataPage'
import PenilaianResultDetailPage from './pages/PenilaianResultDetailPage'
import TeamResultsPage from './pages/TeamResultsPage'
import KPIRevisionPage from './pages/KPIRevisionPage'

const PenilaianModule = () => {
  return (
    <Routes>
      <Route index element={<Navigate to="my-assessments" replace />} />
      <Route path="my-assessments" element={<MyAssessmentsPage />} />
      <Route path="assess/:assignmentId" element={<AssessmentFormPage />} />
      <Route path="my-result" element={<MyResultPage />} />
      <Route path="my-kpis" element={<MyKPIPage />} />
      <Route path="team-kpis" element={<TeamKPIPage />} />
      <Route path="kpi-plans" element={<AllKPIPlansPage />} />
      <Route path="team-results" element={<TeamResultsPage />} />
      <Route path="periods" element={<PenilaianPeriodsPage />} />
      <Route path="periods/:periodId" element={<PeriodDetailPage />} />
      <Route path="assignments" element={<PeerAssignmentAdminPage />} />
      <Route path="kpis" element={<PenilaianKPIPage />} />
      <Route path="kpi-revision" element={<KPIRevisionPage />} />
      <Route path="results" element={<PenilaianResultsPage />} />
      <Route path="results/:resultId" element={<PenilaianResultDetailPage />} />
      <Route path="master-data" element={<MasterDataPage />} />
    </Routes>
  )
}

export default PenilaianModule
